import {Injectable} from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {Observable} from 'rxjs';

@Injectable()

export class NonElectronicCountdownService {

    constructor(private httpService: HttpService) {
    }

    getData(tenderRevisionId, procurementType, selectionMethod): Observable<any> {
        return this.httpService.get(`api/non-electronic/procurement-process/${tenderRevisionId}/countdown?procurement_type=${procurementType}&&selection_method=${selectionMethod}`);
    }
}
